/* globals _paq */
import { formatDefaultLocale } from 'd3-format';
import germanFormat from 'd3-format/locale/de-DE';

const germanNumberFormat = formatDefaultLocale(germanFormat);

export function nf(num, decimals = 0, unit = false) {
  if (typeof num === 'undefined') {
    return '';
  }

  const formattedNumber = germanNumberFormat.format(`,.${decimals}f`)(num);

  return unit ? `${formattedNumber} ${unit}` : formattedNumber;
}

export function trackEvent(name, data) {
  if (typeof _paq !== 'undefined') {
    _paq.push(['trackEvent', name, data, config.headline]);
  }
}

export const parseLabel = (label) => {
  return label
    .replace('500000', '500.000')
    .replace('100000', '100.000')
    .replace('20000', '20.000')
    .replace('5000', '5.000')
    .replace('Maenner', 'Männer');
};

export default {
  nf,
  trackEvent,
  parseLabel,
};
